import qs from 'query-string';

export default function LinkedInCertURLGenerator(props) {
  const {
    certName,
    issueYear,
    issueMonth,
    expirationYear,
    expirationMonth,
    certUrl,
    certId,
  } = props;

  const url = qs.stringifyUrl({
    url: 'https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME',
    query: {
      name: certName,
      organizationId: '18654253',
      issueYear,
      issueMonth,
      expirationMonth,
      expirationYear,
      certUrl,
      certId,
    },
  });

  return url;
}
